import React from 'react'
import { Typography, Button, Divider } from '@material-ui/core'
import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import Review from './Review'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)

const PaymentForm = ({ checkoutToken, shippingData ,nextStep , backStep, handleCaptureCheckout, timeout }) => {
console.log(shippingData)
  const handleSubmit = async (e, elements, stripe) => {
    e.preventDefault()

    if(!stripe || !elements) return

    const cardElement = elements.getElement(CardElement)

    const { error, paymentMethod } = await stripe.createPaymentMethod( {type: 'card', card: cardElement} )

    if(error) {
      console.log('error: ', error)
    } else {
      const orderData = {
        line_items: checkoutToken.live.line_items,
        customer: {
          firstname: shippingData.fistName,
          lastname: shippingData.lastName,
          email: shippingData.email
        },
        shipping: {
          name: `${shippingData.fistName} ${shippingData.lastName}`,
          street: shippingData.address,
          town_city: shippingData.city,
          county_state: shippingData.ShippingSubDivision,
          postal_zip_code: shippingData.zip,
          country: shippingData.ShippingCountry
        },
        fulfillment: {
          shipping_method: shippingData.ShippingOption
        },
        billing: {
          name: `${shippingData.fistName} ${shippingData.lastName}`,
          street: shippingData.address,
          town_city: shippingData.city,
          county_state: shippingData.ShippingSubDivision,
          postal_zip_code: shippingData.zip,
          country: shippingData.ShippingCountry
        },
        payment: {
          gateway: 'stripe',
          card: {
            token: paymentMethod.id
          }
        },
        pay_what_you_want: checkoutToken.live.total.formatted
      }
      handleCaptureCheckout(checkoutToken.id, orderData)
      timeout()
      nextStep()
    }
  }
  return (
    <>
      <Review checkoutToken={checkoutToken}/>
      <Divider />
      <Typography variant="h6" gutterBottom style={{ margin: '20px 0' }}>Payment method</Typography>
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => (
            <form onSubmit={(e) => handleSubmit(e, elements, stripe)}>
              <CardElement />
              <br/> <br/>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Button variant="outlined" onClick={backStep}>Back</Button>
                <Button type="submit" color="primary" variant="contained" disabled={!stripe}>
                  Pay {checkoutToken.live.subtotal.formatted_with_symbol}
                </Button>
              </div>
            </form>
          )}
        </ElementsConsumer>
      </Elements>


    </>
  )
}

export default PaymentForm
